// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-pancadaya{
    margin-left: 43%;
    margin-top: 6%;
}


.icon-pancadaya {
    width: 25%;
    margin-top: 5%;
    display: flex;
    justify-content: center;
}

.card-desc{
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
    margin-top: 40px;
    background-color: #921ABC;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 15px;
    height: auto;
    width: 420px;
    margin-left: 18%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
}

.card-pancadaya{
    margin-left: -41% ;
}

.text-pancadaya{
    font-size: 16px;
    font-weight: bold;
}

.description-pancadaya{
    font-size: 16px;
}

.back-icon-pancadaya{
    margin-top: 5px !important;
    margin-left: -45%;
    display:inline-block;
    color: #fff;
    font-size: 1900;
    position: absolute;
    margin-bottom: 4%;
}

.back-icon-assessor {
    float: left;
    margin-top: 2%;
    padding-left: 4%;
    font-size: 900;
    color: #fff;
  }

.btn-pancadaya{
    margin-left: -4% !important;
}
.btn-panca{
  display: inline-block;
  background-color: #792F7F;
  color: #fff;
  border: 2px solid rgb(8, 96, 128);
  border-radius: 10px;
  border: 4px;
  padding: 10px;
  margin: 5px;
  font-family: 'Poppins';
  font-weight: bold;
  cursor: pointer;
  width: 120px;
  margin-top: 4%;
  margin-bottom: 5%;
}

@media only screen and (max-width: 768px) {
    .icon-pancadaya {
        width: 90%; 
        margin-top: 20%; 
    }
}

@media only screen and (max-width: 480px) {
    .icon-pancadaya {
        width: 140% ; 
        margin-top: 55%; 
        margin-left: -38%;
    }
}

/* Media Query for tablets and larger devices */
@media only screen and (min-width: 768px) {
    .card-desc {
        max-width: 420px;
    }
}

/* Media Query for small desktops and larger devices */
@media only screen and (min-width: 992px) {
    .card-desc {
        max-width: 480px;
        margin-right: -100px !important;
    }
}

/* Media Query for larger desktops */
@media only screen and (min-width: 1200px) {
    .card-desc {
        max-width: 540px;
    }
}

/* Additional Media Query for smaller devices */
@media only screen and (max-width: 480px) {
    .card-desc {
        width: 90%; /* Adjusted width for smaller devices */
        margin-top: 14%; /* Adjusted margin top for smaller devices */
        margin-left: -6%;
    }
}

@media only screen and (max-width: 768px) {
    .btn-pancadaya {
        margin-left: -43% !important; /* Adjusted margin for smaller devices */
        margin-top: 10%;
    }
}

.card-partnershipinequity{
   
    
    width:70%;
}

.card-partner-new{
    display: flex;
    justify-content: center;
    margin-right: 450px;
}


`, "",{"version":3,"sources":["webpack://./src/components/PancadayaPage/PancadayaPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;AAEF;IACI,2BAA2B;AAC/B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,+CAA+C;AAC/C;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,sDAAsD;AACtD;IACI;QACI,gBAAgB;QAChB,+BAA+B;IACnC;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,+CAA+C;AAC/C;IACI;QACI,UAAU,EAAE,uCAAuC;QACnD,eAAe,EAAE,4CAA4C;QAC7D,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,4BAA4B,EAAE,wCAAwC;QACtE,eAAe;IACnB;AACJ;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".logo-pancadaya{\n    margin-left: 43%;\n    margin-top: 6%;\n}\n\n\n.icon-pancadaya {\n    width: 25%;\n    margin-top: 5%;\n    display: flex;\n    justify-content: center;\n}\n\n.card-desc{\n    width: 100%;\n    max-width: 380px;\n    margin: 0 auto;\n    margin-top: 40px;\n    background-color: #921ABC;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 15px;\n    height: auto;\n    width: 420px;\n    margin-left: 18%;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    transition: 0.3s;\n}\n\n.card-pancadaya{\n    margin-left: -41% ;\n}\n\n.text-pancadaya{\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.description-pancadaya{\n    font-size: 16px;\n}\n\n.back-icon-pancadaya{\n    margin-top: 5px !important;\n    margin-left: -45%;\n    display:inline-block;\n    color: #fff;\n    font-size: 1900;\n    position: absolute;\n    margin-bottom: 4%;\n}\n\n.back-icon-assessor {\n    float: left;\n    margin-top: 2%;\n    padding-left: 4%;\n    font-size: 900;\n    color: #fff;\n  }\n\n.btn-pancadaya{\n    margin-left: -4% !important;\n}\n.btn-panca{\n  display: inline-block;\n  background-color: #792F7F;\n  color: #fff;\n  border: 2px solid rgb(8, 96, 128);\n  border-radius: 10px;\n  border: 4px;\n  padding: 10px;\n  margin: 5px;\n  font-family: 'Poppins';\n  font-weight: bold;\n  cursor: pointer;\n  width: 120px;\n  margin-top: 4%;\n  margin-bottom: 5%;\n}\n\n@media only screen and (max-width: 768px) {\n    .icon-pancadaya {\n        width: 90%; \n        margin-top: 20%; \n    }\n}\n\n@media only screen and (max-width: 480px) {\n    .icon-pancadaya {\n        width: 140% ; \n        margin-top: 55%; \n        margin-left: -38%;\n    }\n}\n\n/* Media Query for tablets and larger devices */\n@media only screen and (min-width: 768px) {\n    .card-desc {\n        max-width: 420px;\n    }\n}\n\n/* Media Query for small desktops and larger devices */\n@media only screen and (min-width: 992px) {\n    .card-desc {\n        max-width: 480px;\n        margin-right: -100px !important;\n    }\n}\n\n/* Media Query for larger desktops */\n@media only screen and (min-width: 1200px) {\n    .card-desc {\n        max-width: 540px;\n    }\n}\n\n/* Additional Media Query for smaller devices */\n@media only screen and (max-width: 480px) {\n    .card-desc {\n        width: 90%; /* Adjusted width for smaller devices */\n        margin-top: 14%; /* Adjusted margin top for smaller devices */\n        margin-left: -6%;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .btn-pancadaya {\n        margin-left: -43% !important; /* Adjusted margin for smaller devices */\n        margin-top: 10%;\n    }\n}\n\n.card-partnershipinequity{\n   \n    \n    width:70%;\n}\n\n.card-partner-new{\n    display: flex;\n    justify-content: center;\n    margin-right: 450px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
